"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _LavatoryTile = _interopRequireDefault(require("./LavatoryTile.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var LavatoryContainer = _styledComponents.default.span.withConfig({
  displayName: "LavatoryTile__LavatoryContainer",
  componentId: "sc-1y9cpnb-0"
})(["display:inline-flex;justify-content:center;align-items:center;border:1px solid ", ";width:", ";padding:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyMedium;
}, function (_ref2) {
  var width = _ref2.width;
  return width || '100%';
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.none);
});

var LavatoryTile = function LavatoryTile(props) {
  var accessible = props.accessible,
      theme = props.theme,
      customProperties = props.customProperties,
      width = props.width;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(LavatoryContainer, {
      width: width,
      "aria-label": "Lavatory icon"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      customProperties: customProperties,
      icon: "WashroomIcon",
      fontsize: "medium",
      className: "direction-icon",
      color: "greyDark"
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

LavatoryTile.propTypes = _LavatoryTile.default.PropTypes;
LavatoryTile.defaultProps = _LavatoryTile.default.DefaultProps;
var _default = LavatoryTile;
exports.default = _default;